import { render, staticRenderFns } from "./paymentsbymonthreport.vue?vue&type=template&id=36e1f826"
import script from "./paymentsbymonthreport.vue?vue&type=script&lang=js"
export * from "./paymentsbymonthreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports